import { ReactNode } from 'react';

type HeadingProps = {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  size?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
  children?: ReactNode;
};

const headingStyles: Record<number, string> = {
  1: 'text-4xl font-black lg:text-5xl',
  2: 'text-3xl font-bold tracking-tight lg:text-4xl',
  3: 'text-2xl font-bold tracking-tight lg:text-2xl',
  4: 'text-xl font-bold tracking-tight',
  5: 'text-lg font-medium tracking-tight',
  6: 'text-sm font-medium tracking-tight',
};

export function Heading({ level = 1, size, className, children, ...props }: HeadingProps) {
  const Tag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  return (
    <Tag
      className={`${headingStyles[size || level]} ${className}`}
      children={children}
      {...props}
    />
  );
}
